import { createSelector } from "reselect";

const selectPasswordRecovery = (state) => state.passwordRecovery;

export const selectIsPasswordRecoverLoading = createSelector(
  [selectPasswordRecovery],
  (passwordRecovery) => passwordRecovery.isLoading
);
